import { render } from "./Index.vue?vue&type=template&id=34ca6de0&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=34ca6de0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-34ca6de0"

export default script